import { render } from "./TopbarTemplate.vue?vue&type=template&id=4c08c032"
import script from "./TopbarTemplate.vue?vue&type=script&lang=js"
export * from "./TopbarTemplate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__